/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { ClosedEnum } from "../../types/enums.js";

export const KillswitchCapabilityKey = {
  McpToolCalls: "mcp_tool_calls",
} as const;
export type KillswitchCapabilityKey = ClosedEnum<
  typeof KillswitchCapabilityKey
>;

/** @internal */
export const KillswitchCapabilityKey$inboundSchema: z.ZodMiniEnum<
  typeof KillswitchCapabilityKey
> = z.enum(KillswitchCapabilityKey);
/** @internal */
export const KillswitchCapabilityKey$outboundSchema: z.ZodMiniEnum<
  typeof KillswitchCapabilityKey
> = KillswitchCapabilityKey$inboundSchema;
